module.exports = __webpack_public_path__ + "img/visa.5fec3e5f.svg";